import { Injectable } from '@angular/core';
import { BrowserInfo, DeviceInfo, DeviceInfoService, OSName } from './device-info.service';

interface NavigatorStandalone extends Navigator {
  standalone?: boolean;
}
export interface UserAlert {
  version: string,
  message: string,
  launchMode: LaunchMode,
  OS: OSName;
}

export enum LaunchMode {
  InstalledApp = 'installed_app',
  BrowserShortcut = 'browser_shortcut',
  DirectLink = 'direct_link',
  Unknown = 'unknown'
}

@Injectable({
  providedIn: 'root'
})
export class LaunchDetectionService {

  userAlerts: UserAlert[] = [
    { OS: OSName.iOS, version: '17', launchMode: LaunchMode.InstalledApp, message: 'Apple has recently introduced a bug in iOS 17 that affects installed web apps. This bug prevents us from keeping the screen awake while you are recording, which can result in a failed recording if your screen locks. To ensure the best results, we recommend using MedicAI directly through your browser on this device.' }
  ];

  constructor(private deviceInfo: DeviceInfoService) { }

  isInstalledApp(): boolean {
    const nav = window.navigator as NavigatorStandalone;
    return (window.matchMedia('(display-mode: standalone)').matches || nav.standalone) as boolean;
  }

  isBrowserShortcut(): boolean {
    const nav = window.navigator as NavigatorStandalone;
    return (document.referrer.startsWith('android-app://') || nav.standalone) as boolean;
  }

  isDirectLink(): boolean {
    return !this.isInstalledApp() && !this.isBrowserShortcut();
  }

  getLaunchMode(): LaunchMode {
    if (this.isInstalledApp()) {
      return LaunchMode.InstalledApp;
    } else if (this.isBrowserShortcut()) {
      return LaunchMode.BrowserShortcut;
    } else if (this.isDirectLink()) {
      return LaunchMode.DirectLink;
    } else {
      return LaunchMode.Unknown;
    }
  }

  /**
   * REMOVED by `tasks/announcements.md` Phase F5.
   *
   * This returned a hardcoded list of notices filtered on browser version, OS and launch mode, and
   * `app.component.ts` opened them in an `IMPORTANT NOTICE` dialog on boot. It is the ancestor of
   * the announcements feature: same job, but the text could only change by shipping a release.
   *
   * Its replacement is `GET /api/announcements`, authored in the admin dashboard. Do not
   * reintroduce a second boot-time modal here — the two would stack.
   */
}
